module.exports = __webpack_public_path__ + "static/img/avatar.f15f055a.png";